import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useState } from 'react';
import React from 'react';
import { formatDateToUserTimezone } from './Useful';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { AccountIcons } from '../../components/general/AccountIcons';

function ScheduledPost({ myItem, viewMode = 'card', onDeleted }) {
  const navigate = useNavigate();
  const myContext = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/deleteScheduledPost', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postId: myItem.id }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success('Post deleted.');
        myContext.setJWTLocal?.(); // keeps calendar view in sync
        onDeleted?.();
      } else {
        toast.error(data.message || 'Failed to delete post.');
      }
    } catch {
      toast.error('An error occurred.');
    } finally {
      setDeleting(false);
      setShowModal(false);
    }
  };

  if (viewMode === 'list') {
    return (
      <div className="col-12" style={{ marginBottom: 8 }}>
        <div style={{
          background: '#fff',
          border: '1px solid #d1d9e0',
          borderLeft: '4px solid #3b82f6',
          borderRadius: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          padding: '11px 16px',
        }}>

          {/* Left: accounts + date */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5, flexShrink: 0, width: 190 }}>
            <AccountIcons accounts={myItem.accounts} />
            <span style={{ fontSize: '0.72rem', color: '#1d4ed8', fontWeight: 600 }}>
              <Icon.Clock size={10} style={{ marginRight: 3, verticalAlign: 'middle' }} />
              {formatDateToUserTimezone(myItem.scheduled_date)}
            </span>
          </div>

          {/* Content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{
              fontSize: '0.875rem', color: '#334155', lineHeight: 1.5,
              margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {myItem.content || <span style={{ color: '#94a3b8' }}>No content</span>}
            </p>
          </div>

          {/* Images preview */}
          {myItem.images?.length > 0 && (
            <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
              {myItem.images.slice(0, 2).map((img, i) => (
                <img
                  key={i}
                  src={img.url}
                  alt=""
                  style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #d1d9e0' }}
                />
              ))}
            </div>
          )}

          {/* Actions */}
          <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
            <button
              className="btn btn-sm"
              style={{ fontSize: '0.78rem', border: '1px solid #d1d9e0', borderRadius: 7, color: '#475569', background: '#fff' }}
              onClick={() => navigate('/single-post/' + myItem.id)}
            >
              <Icon.Eye size={12} className="me-1" /> View
            </button>
            <button
              className="btn btn-sm"
              style={{ fontSize: '0.78rem', border: '1px solid #d1d9e0', borderRadius: 7, color: '#475569', background: '#fff' }}
              onClick={() => navigate('/single-post/' + myItem.id)}
            >
              <Icon.Edit2 size={12} className="me-1" /> Edit
            </button>
            <button
              className="btn btn-sm"
              style={{ fontSize: '0.78rem', border: '1px solid #fecaca', borderRadius: 7, color: '#dc2626', background: '#fff' }}
              onClick={() => setShowModal(true)}
            >
              <Icon.Trash2 size={12} />
            </button>
          </div>
        </div>

        {/* Delete modal */}
        {showModal && (
          <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.45)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{ borderRadius: 12, border: 'none' }}>
                <div className="modal-header" style={{ border: 'none', paddingBottom: 0 }}>
                  <h6 className="modal-title" style={{ fontWeight: 500 }}>Delete scheduled post?</h6>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>
                <div className="modal-body" style={{ fontSize: '0.875rem', color: '#64748b' }}>
                  This action cannot be undone.
                </div>
                <div className="modal-footer" style={{ border: 'none' }}>
                  <button className="btn btn-sm sp-btn-ghost" style={{ border: '1px solid #d1d9e0', borderRadius: 8 }} onClick={() => setShowModal(false)} disabled={deleting}>
                    Cancel
                  </button>
                  <button className="btn btn-sm btn-danger" style={{ borderRadius: 8 }} onClick={handleDelete} disabled={deleting}>
                    {deleting ? 'Deleting…' : 'Delete'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="col-12 col-md-6 col-xl-3" style={{ marginBottom: 20 }}>
      <div style={{
        background: '#fff',
        border: '1px solid #b0bec5',
        borderTop: '3px solid #3b82f6',
        borderRadius: 12,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}>

        {/* Top row: accounts + date badge */}
        <div style={{ padding: '14px 16px 0', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
          <AccountIcons accounts={myItem.accounts} />
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            background: '#eff6ff', color: '#1d4ed8',
            fontSize: '0.72rem', fontWeight: 600,
            padding: '3px 8px', borderRadius: 20, whiteSpace: 'nowrap', flexShrink: 0,
          }}>
            <Icon.Clock size={11} />
            {formatDateToUserTimezone(myItem.scheduled_date)}
          </span>
        </div>

        {/* Content */}
        <div style={{ padding: '12px 16px', flexGrow: 1 }}>
          <p style={{ fontSize: '0.875rem', color: '#334155', lineHeight: 1.65, margin: 0 }}>
            {myItem.content?.substring(0, 180)}
            {myItem.content?.length > 180 && <span style={{ color: '#94a3b8' }}>…</span>}
          </p>

          {myItem.images?.length > 0 && (
            <div className="d-flex flex-wrap gap-2 mt-3">
              {myItem.images.slice(0, 3).map((img, i) => (
                <a key={i} href={img.url} target="_blank" rel="noopener noreferrer">
                  <img src={img.url} alt="" style={{
                    width: 68, height: 68, objectFit: 'cover',
                    borderRadius: 8, border: '1px solid #d1d9e0',
                  }} />
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '10px 16px',
          borderTop: '1px solid #e8edf2',
          display: 'flex', alignItems: 'center', gap: 6,
        }}>
          <button
            className="btn btn-sm sp-btn-ghost"
            style={{ fontSize: '0.78rem', border: '1px solid #d1d9e0', borderRadius: 7, color: '#475569', background: '#fff' }}
            onClick={() => navigate('/single-post/' + myItem.id)}
          >
            <Icon.Eye size={12} className="me-1" /> View
          </button>
          <button
            className="btn btn-sm sp-btn-ghost"
            style={{ fontSize: '0.78rem', border: '1px solid #d1d9e0', borderRadius: 7, color: '#475569', background: '#fff' }}
            onClick={() => navigate('/single-post/' + myItem.id)}
          >
            <Icon.Edit2 size={12} className="me-1" /> Edit
          </button>
          <button
            className="btn btn-sm ms-auto sp-btn-danger"
            style={{ fontSize: '0.78rem', border: '1px solid #fecaca', borderRadius: 7, color: '#dc2626', background: '#fff' }}
            onClick={() => setShowModal(true)}
          >
            <Icon.Trash2 size={12} />
          </button>
        </div>
      </div>

      {/* Delete modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.45)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: 12, border: 'none' }}>
              <div className="modal-header" style={{ border: 'none', paddingBottom: 0 }}>
                <h6 className="modal-title" style={{ fontWeight: 500 }}>Delete scheduled post?</h6>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body" style={{ fontSize: '0.875rem', color: '#64748b' }}>
                This action cannot be undone.
              </div>
              <div className="modal-footer" style={{ border: 'none' }}>
                <button className="btn btn-sm sp-btn-ghost" style={{ border: '1px solid #d1d9e0', borderRadius: 8 }} onClick={() => setShowModal(false)} disabled={deleting}>
                  Cancel
                </button>
                <button className="btn btn-sm btn-danger" style={{ borderRadius: 8 }} onClick={handleDelete} disabled={deleting}>
                  {deleting ? 'Deleting…' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScheduledPost;
